/**Returns ISO date format (YYYY-MM-DDTHH:mm:ss) but without the timezone (Z).  */
export function getCurrentDateString() {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set time to midnight without affecting timezone

  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure two digits
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}T00:00:00`;
}
